<template>
    <v-alert
        v-if="showAlert"
        :type="alertType"
        class="mx-auto text-center"
        style="position: fixed; top: 20px; left: 0; right: 0; z-index: 9999; max-width: 600px;"
        elevation="2"
        prominent
    >
        {{ alertMessage }}
    </v-alert>
    <v-container fluid>
        <v-card class="pa-4" elevation="2">
            <v-row>
                <v-col class="headline mb-4">
                    <h2>Lineas de Campañas</h2>
                </v-col>
                <v-col cols="12" sm="6" style="text-align: right">
                    <v-btn style="margin-left: 10px"  @click="$router.back()">Volver</v-btn>
                </v-col>
            </v-row>

            <v-data-table
                :items="campaignLines"
                :headers="headers"
                class="elevation-1"
                item-value="id"
                no-data-text="No hay lineas de campañas disponibles"
            >
            </v-data-table>
        </v-card>
    </v-container>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import axios from 'axios'

const campaignLines = ref([])
const route = useRoute()

import { useAlert } from '@/composables/useAlert'

const {
    alertMessage,
    alertType,
    showAlert,
    showAlertMessage
} = useAlert()

const headers = [
    { title: 'Campaña', value: 'campaign.name' , sortable: true},
    { title: 'Cantidad', value: 'quantity' , sortable: true},
    { title: 'Fecha inicio', value: 'start_date' , sortable: true},
    { title: 'Fecha fin', value: 'end_date' , sortable: true},
    { title: 'Flyer', value: 'flyer_reference' , sortable: true}
]

const fetchCampaignLines = async () => {
    try {
        const odooId = route.params.id
        const { data } = await axios.get(`/api/admin/campaigns/${odooId}/lines`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`
            }
        })
        campaignLines.value = data
    } catch (e) {
        console.error('Error al cargar líneas de campaña:', e)
        showAlertMessage('Error al cargar líneas de campaña.', 'error')
        if (e.response?.status === 401) {
            localStorage.removeItem('token')
            await router.push('/')
        }
    }
}

onMounted(fetchCampaignLines)
</script>
